import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getTeamUrl, priceGroupIdUrl } from "src/react-query/endPoints";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
export const PriceGroupActionMenu = ({ id }) => {
  const isReadOnly = useAccess(FEATURE.PRICEGROUP, "R");
  const hasEditAccess = useAccess(FEATURE.PRICEGROUP, "U");
  const hasDeleteAccess = useAccess(FEATURE.PRICEGROUP, "D");
  const { teamId } = useSelectedTeam();
  const { mutate } = useMutate("priceGroups");
  const onDelete = useCallback(() => {
    mutate({ url: getTeamUrl(teamId, priceGroupIdUrl(id)), method: "DELETE" });
  }, [teamId, id, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
